<template>
  <v-card outlined class="entity-detail-section mb-4">
    <v-card-title class="entity-detail-section__title">
      <v-icon v-if="icon" small class="mr-2" color="primary">{{ icon }}</v-icon>
      {{ title }}
    </v-card-title>
    <v-divider />
    <v-card-text class="entity-detail-section__body">
      <slot />
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "EntityDetailSection",
  props: {
    title: { type: String, required: true },
    icon: { type: String, default: "" },
  },
});
</script>

<style scoped lang="scss">
.entity-detail-section {
  border-radius: 12px !important;
  border-color: rgba(0, 0, 0, 0.08) !important;
}

.entity-detail-section__title {
  font-size: 1rem !important;
  font-weight: 700 !important;
  color: #1f243f !important;
  padding: 16px 20px !important;
}

.entity-detail-section__body {
  padding: 20px !important;
}
</style>
